export default function exec() {
	if (typeof $$epiforms === 'undefined' || !document.querySelector('.FormAddressElement')) {
		return;
	}

	(function ($) {		

		const _utilsSvc =
			(typeof epi !== 'undefined' && epi.EPiServer && epi.EPiServer.Forms)
				? epi.EPiServer.Forms.Utils
				: null;

		const addressComponentsMap = {
			street_number: 'short_name',
			route: 'long_name',
			locality: 'long_name',
			administrative_area_level_1: 'long_name',
			country: 'long_name',
			postal_code: 'short_name'
		};

		function handleKeyDown(e) {
			if (e.keyCode === 13) { //keycode 13 is for Enter key
				if ($('.pac-container:visible').length) {
					e.preventDefault();
				} else if (_utilsSvc) {
					_utilsSvc.showNextStepOnEnterKeyDown(e);
				}
			}
		}

		function populateAddressFields(addressElementInfo, geoComponents) {
			const addressComponents = geoComponents.address_components;

			$('input[id^="' + addressElementInfo.guid + '"]').val('');

			if (!addressComponents || !addressComponents.length) {
				return;
			}

			$("#" + addressElementInfo.guid + '_address').val(geoComponents.name);

			addressComponents.forEach(component => {
				const addressType = component.types[0];

				if (!addressComponentsMap[addressType]) {
					return;
				}

				const el = $("#" + addressElementInfo.guid + '_' + addressType);
				el.val(component[addressComponentsMap[addressType]]);
			});
		}

		function createPlaceChangedHandler(gPlace, addressElementInfo) {
			return function () {
				const geoComponents = gPlace.getPlace();
				populateAddressFields(addressElementInfo, geoComponents);
			};
		}

		function initializeAutocomplete(addressEl, addressElementInfo) {
			if (!globalThis.google || !globalThis.google.maps || !globalThis.google.maps.places) {
				return;
			}

			const options = {
				types: ['address'],
				componentRestrictions: { country: 'au' }
			};

			const gPlace = new google.maps.places.Autocomplete(addressEl[0], options);

			google.maps.event.addListener(
				gPlace,
				'place_changed',
				createPlaceChangedHandler(gPlace, addressElementInfo)
			);
		}

		function initializeAddressElement(addressElementInfo) {
			let addressEl = $("#" + addressElementInfo.guid + '_address');

			if (!addressEl || addressEl.length < 1) {
				return;
			}

			$("#" + addressElementInfo.guid + '_map').hide();

			const freshEl = addressEl.clone();
			addressEl.replaceWith(freshEl);
			addressEl = freshEl;

			$('.EPiServerForms .FormAddressElement .Form__CustomInput')
				.off('keydown._onKeyDown')
				.on('keydown._onKeyDown', handleKeyDown);

			initializeAutocomplete(addressEl, addressElementInfo);
		}

		function initAddressElements() {
			if (typeof __SamplesAddressElements === "undefined") {
				return;
			}

			$.each(__SamplesAddressElements || [], function (_, addressElementInfo) {
				initializeAddressElement(addressElementInfo);
			});
		}

		if (document.readyState === "complete") {
			initAddressElements();
		} else {
			$(window).on("load", initAddressElements);
		}
	})($$epiforms);
}


// WEBPACK FOOTER //
// ./project/client/src/core/modules/epiforms/addresses-element-block.js